import React from 'react';
import { FileText, Users, ClipboardCheck, FileCheck, Calendar, BoxIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    badge: 'BONUS 01',
    icon: FileText,
    title: 'La Planilla Maestra de Notas',
    subtitle: 'Sistema Automático en Google Sheets',
    description: 'Calculá promedios, detectá alumnos en riesgo y administrá 200 alumnos en 15 minutos semanales. Sin fórmulas manuales. Sin errores.',
    value: 'Valor $6.990 → GRATIS'
  }, {
    badge: 'BONUS 02',
    icon: Users,
    title: 'Kit de Comunicación con Padres',
    subtitle: '30 Plantillas Listas para Enviar',
    description: 'Informes de bajo desempeño, citaciones, notas de cuaderno y respuestas a padres difíciles. Copiá, completá los corchetes y enviá.',
    value: 'Valor $4.990 → GRATIS'
  }, {
    badge: 'BONUS 03',
    icon: BoxIcon,
    title: 'Laboratorio en el Aula',
    subtitle: '6 Experimentos Sin Laboratorio',
    description: 'Ciencia real con materiales de menos de $1.000. Ley de Boyle con jeringa, indicador ácido-base con repollo colorado, circuitos con grafito y más.',
    value: 'Valor $5.990 → GRATIS'
  }, {
    badge: 'BONUS 04',
    icon: ClipboardCheck,
    title: 'Pack de Seguimiento de Alumnos',
    subtitle: 'Semáforo Visual de Progreso',
    description: 'Fichas individuales, nivelómetro por curso y registro de entregas. Detectá quién necesita ayuda antes de desaprobar, no después.',
    value: 'Valor $5.990 → GRATIS'
  }, {
    badge: 'BONUS 05',
    icon: FileCheck,
    title: 'Plantillas de Exámenes Recuperatorios',
    subtitle: 'Nunca Más Desde Cero',
    description: 'Modelos de recuperatorios, instancias para ausentes, actas oficiales y criterios de corrección incluidos.',
    value: 'Valor $5.990 → GRATIS'
  }, {
    badge: 'BONUS 06',
    icon: Calendar,
    title: 'Pack de Organización Semanal Docente',
    subtitle: '"El Domingo Sin Caos"',
    description: 'Planificador semanal semáforo, control de avance por curso y el Ritual del Domingo de 60 minutos para cerrar la semana con todo listo.',
    value: 'Valor $4.990 → GRATIS'
  }];
  return <section className="bg-gray-100 py-12 md:py-16 px-4" data-id="element-24">
      <div className="max-w-4xl mx-auto" data-id="element-25">
        {/* Free today banner */}
        <div className="bg-bio-green text-white text-center py-3 px-4 rounded-lg mb-8 font-bold text-lg" data-id="element-26">
          🎁 GRATIS SOLO POR HOY
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-carbon text-center mb-4" data-id="element-27">
          Más los 6 Regalos Estratégicos
        </h2>
        <p className="text-center text-gray-600 mb-10" data-id="element-28">
          Incluidos en todas las ofertas — sin costo extra
        </p>

        <div className="space-y-6" data-id="element-29">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="bg-white p-6 rounded-lg border-l-4 border-sci-orange shadow-sm" data-id="element-30">
                <div className="flex gap-4" data-id="element-31">
                  <div className="w-12 h-12 bg-sci-orange/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-32">
                    <Icon className="w-6 h-6 text-sci-orange" data-id="element-33" />
                  </div>
                  <div className="flex-1" data-id="element-34">
                    <div className="inline-block bg-sci-orange text-white text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-35">
                      {bonus.badge}
                    </div>
                    <h3 className="font-bold text-carbon text-lg mb-1" data-id="element-36">
                      {bonus.title}
                    </h3>
                    <h4 className="text-sci-orange text-sm font-semibold mb-2" data-id="element-37">
                      {bonus.subtitle}
                    </h4>
                    <p className="text-gray-700 text-sm mb-3" data-id="element-38">
                      {bonus.description}
                    </p>
                    <div className="inline-block bg-bio-green text-white text-xs font-bold px-3 py-1 rounded" data-id="element-39">
                      {bonus.value}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}